export enum ProviderSignOnBonusTier {
  tier1 = 'tier_1',
  tier2 = 'tier_2',
}
